import React from 'react';
import {Query, Mutation} from 'react-apollo';
import {adopt} from 'react-adopt';

import {GET_STARTERPACKS, GET_STARTERPACK_DATA, UPDATE_STARTERPACK, GET_CLUB_LANGUAGES} from '../../../../graphql';
import {Region, Club, Starterpack, StarterpackText, Language} from '../../../../interfaces';

export interface QueryAndMutationForStarterpackObject {
  starterpackData: {
    starterpack?: Starterpack;
    club?: Club;
    region?: Region;
    loading?: boolean;
    error?: Error;
  };
  starterpacks: {
    loading?: boolean;
    error?: Error;
    starterpacks?: Array<any>;
  };
  clubLanguages: {
    loading?: boolean;
    error?: Error;
    languages?: Array<Language>;
  };
  updateStarterpack: (data: UpdateStarterpackInput) => Promise<Starterpack>;
}

export interface UpdateStarterpackInput {
  variables: {
    data: {
      id: string | number;
      externalStarterPackId: string;
      active: boolean;
      ospAvailable: boolean;
      dspAvailable: boolean;
      isDefault: boolean;
      priority: number;
      texts: Array<{
        id: string;
        title: string;
        description: string;
      }>;
    };
  };
}

const QueryAndMutationForStarterpack = adopt({
  starterpackData: ({render, clubId, regionId, externalStarterPackId}) => (
    <Query query={GET_STARTERPACK_DATA} variables={{clubId, regionId, externalStarterPackId}}>
      {({loading, error, data: {club, starterpack, region}}: any) => {
        if (loading) {
          return render({loading});
        }

        if (error) {
          return render({error});
        }

        if (!starterpack) {
          return render({
            starterpack,
            club,
            region,
          });
        }

        const parsedStarterpack: Starterpack = {
          id: starterpack.id,
          active: starterpack.active,
          externalStarterPackId: starterpack.externalStarterPackId,
          priority: starterpack.priority,
          ospAvailable: starterpack.ospAvailable,
          dspAvailable: starterpack.dspAvailable,
          isDefault: starterpack.isDefault,
          texts: starterpack.texts.map((text: StarterpackText) => ({
            id: text && text.id,
            title: text && text.title,
            description: text && text.description,
            language: {
              id: text && text.language && text.language.id,
              code: text && text.language && text.language.code,
              name: text && text.language && text.language.name,
            },
          })),
        };

        return render({
          starterpack: parsedStarterpack,
          club,
          region,
        });
      }}
    </Query>
  ),
  starterpacks: ({render, clubId}) => (
    <Query query={GET_STARTERPACKS} variables={{clubId}}>
      {({loading, error, data: {starterpacks}}: any) => {
        if (loading) {
          return render({loading});
        }

        if (error) {
          return render({error});
        }

        return render({starterpacks});
      }}
    </Query>
  ),
  clubLanguages: ({render, clubId}) => (
    <Query query={GET_CLUB_LANGUAGES} variables={{clubId}}>
      {({loading, error, data: {clubLanguages}}: any) => {
        if (loading) {
          return render({loading});
        }

        if (error) {
          return render({error});
        }

        return render({languages: clubLanguages});
      }}
    </Query>
  ),
  updateStarterpack: ({render, clubId, regionId, externalStarterPackId}) => (
    <Mutation
      mutation={UPDATE_STARTERPACK}
      variables={{clubId}}
      refetchQueries={[
        {query: GET_STARTERPACK_DATA, variables: {clubId, regionId, externalStarterPackId}},
        {query: GET_STARTERPACKS, variables: {clubId}},
      ]}
    >
      {(updateStarterpack: any) => render(updateStarterpack)}
    </Mutation>
  ),
});

export default QueryAndMutationForStarterpack;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackDetail/components/QueryMutation/QueryMutation.tsx